  @if (showBadge) {
    <a [routerLink]="item.route" routerLinkActive="colorRed" #rla="routerLinkActive" pBadge severity="danger" [title]="item.label">
      <fa-icon [icon]="item.icon" class="iconClass" [ngStyle]="{'color': rla.isActive ? 'var(--red-500)' : 'var(--primary-color)'}" ></fa-icon>
    </a>
  } @else {
    <a [routerLink]="item.route" routerLinkActive="colorRed" #rla="routerLinkActive" [title]="item.label">
      <fa-icon [icon]="item.icon" class="iconClass" [ngStyle]="{'color': rla.isActive ? 'var(--red-500)' : 'var(--primary-color)'}"></fa-icon>
    </a>
  }
